/**
 * openMsg.jsx
 *
 * @Author: jruif
 * @Date: 2018/2/8 下午5:03
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import {
  Icon, Tooltip, Row, Col, Tabs,
} from 'neatui';
import { paramMsgString } from '../message';
import Loading from '../loading';
import ajax from '../../util/ajax';
import './openMsg.scss';

class OpenMsg extends React.PureComponent {
  static displayName = 'NeatUI.openMsg';

  static propTypes = {
    user: PropTypes.object,
  };

  static defaultProps = {};

  constructor(props, context) {
    super(props, context);
    this.tabsData = [{ type: 'my', title: '我的消息' }, { type: 'sub', title: '子账号消息' }];
    this.state = {
      loading: false,
      openMsg: false,
      mcn: 'my',
    };
  }

  getMessage = () => {
    const { updateMsg, updateState } = this.props;
    this.setState({
      loading: true,
      openMsg: true,
    });
    ajax(
      this.state.mcn === 'sub' ? '/mcn/message/list.do' : '/msg/list.do',
      {
        params: {
          state: 0,
          pageNo: 1,
          size: 10,
        },
      },
      rs => {
        updateMsg('unRead', rs.data.list);
        updateState();
      },
    ).then(() => {
      this.setState({
        loading: false,
      });
    });
  };

  closeMessage = () => {
    this.setState({
      openMsg: false,
    });
  };

  onChangeTab = value => {
    this.setState(
      {
        mcn: value,
      },
      () => {
        this.getMessage();
      },
    );
  };

  render() {
    const {
      user, message, msgRoute, className, msgProjectLink,
    } = this.props;
    const { mcn, openMsg, loading } = this.state;
    const unreadCnt = className === 'mcnMsg' ? user.mcnUnreadCnt : user.unreadCnt;
    return (
      <Tooltip
        trigger="click"
        position="bottomRight"
        title={(
          <Row>
            {className === 'mcnMsg' && (
            <Col>
              <Tabs
                className="tooltip-tab"
                defaultValue={mcn}
                onChange={(event, value) => this.onChangeTab(value)}>
                {this.tabsData.map(item => (
                  <Tabs.Tab value={item.type} key={item.type}>
                    {item.title}
                  </Tabs.Tab>
                ))}
              </Tabs>
            </Col>
            )}
            <Col>
              <div className="unread">
                {unreadCnt}
                条未读消息
              </div>
            </Col>
          </Row>
)}
        className={classNames('unreadCnt', className)}
        content={(
          <span>
            <Icon type="mail" />
            {unreadCnt > 10 ? '10+' : unreadCnt}
          </span>
)}
        onOpen={this.getMessage}
        isOpen={openMsg}
        onClose={this.closeMessage}>
        <Loading show={loading}>
          <ul className="message">
            {message.length > 0 ? (
              message.map((item, i) => (
                <li key={i}>
                  {mcn === 'sub' && <p>{item.childTname}</p>}
                  <p>{paramMsgString(item.body)}</p>
                  <p className="time">{item.createTime}</p>
                </li>
              ))
            ) : (
              <li>
                <div className="no-result-init">
                  <span>暂无未读消息</span>
                </div>
              </li>
            )}
          </ul>
        </Loading>
        <p className="read-more">
          {msgProjectLink ? (
            <a href={msgProjectLink}>查看全部消息</a>
          ) : (
            <Link to={msgRoute} onClick={this.closeMessage}>
              查看全部消息
            </Link>
          )}
        </p>
      </Tooltip>
    );
  }
}

export default OpenMsg;
